var map = {
	"./_template.json": [
		"../locale/res/translations/_template.json",
		0
	],
	"./de.json": [
		"../locale/res/translations/de.json",
		1
	],
	"./es.json": [
		"../locale/res/translations/es.json",
		2
	],
	"./ru.json": [
		"../locale/res/translations/ru.json",
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../locale/res/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;